<template>
    <div class="page-module-wrap">
        <div class="section-gap">
            <div class="block clearfix">
                <div class="control fleft search-component">
                    <label style="font-weight: bold;color: #000">投票标题</label>
                    <!--<el-select v-model="selectedBlogger" filterable placeholder="请选择">
                        <el-option
                                v-for="item in bloggers"
                                :key="item.bloggerId"
                                :label="item.name"
                                :value="item.bloggerId">
                        </el-option>
                    </el-select>-->
                    <input style="width: 300px" type="text" v-model="search.title">
                        <label class="label inline-block r-top">开放时间</label>
                            <span class="inline-block">
                                <el-date-picker
                                        v-model="search.startTime"
                                        type="datetime"
                                        placeholder="放行开始时间"
                                        align="right">
                                </el-date-picker>
                                <span class="r-top">~</span>
                                <el-date-picker
                                        v-model="search.endTime"
                                        type="datetime"
                                        placeholder="放行结束时间"
                                        align="right">
                                </el-date-picker>
                             </span>
                    <button class='button is-primary' @click="searchVote">搜索</button>
                    <button class="button is-info" style="margin-left: 20px;" @click="clear">清空</button>
                </div>
            </div>
        </div>

        <div class="list-wrap">
            <div class="like-button">
                <p class="buttonStyle">
                    <button class="button is-success margin-top" @click="goEdit(0)">插入投票卡片</button>
                </p>
            </div>
            <div v-if="count > 0" class="clearfix">
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="search.page"
                        :page-size="search.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="count"
                        class="fright">
                </el-pagination>
            </div>
            <div class="">
                <article  v-for="(item,index) in list" class="vote-card block">
                    <div class="vote-title">
                        <div>
                            <span>投票标题</span>
                            <span class="title-con">{{item.title}}</span>
                            <span v-if="item.showStatus==0" style="background: #1e88e5;color: #fff;padding:2px 5px 2px">未开始</span>
                            <span v-if="item.showStatus==1" style="background: #4dc340;color: #fff;padding:2px 5px 2px">开放中</span>
                            <span v-if="item.showStatus==2" style="background: #000;color: #fff;padding:2px 5px 2px">已结束</span>
                        </div>
                    </div>
                    <div class="vote-tab">
                        <div>
                            <span>票数</span>
                            <span class="color" :class="{'vote-active':item.isShowFake===1}" @click="changeShowFake(1,index)">全部</span>
                            <span class="color" :class="{'vote-active':item.isShowFake===0}" @click="changeShowFake(0,index)">真实</span>
                        </div>
                    </div>
                    <div class="block vote-content">
                        <div class="fleft vote-options">
                            <p>选项</p>
                            <div  class="vote-item" v-for="(optionItem,optionIndex) in item.options">
                                <div v-if="item.isShowFake">
                                    <div class="fleft">
                                        <p style="padding-bottom: 10px">{{optionItem.optionName}}</p>
                                        <div class="vote-progress">
                                            <div class="true fleft" :style="{'width':(optionItem.voteCount/(item.voteTotalCount+item.fakeTotalCount)*100)+'%'}"></div>
                                            <div class="fake fleft" :style="{'width':(optionItem.fakeCount/(item.voteTotalCount+item.fakeTotalCount)*100)+'%'}"></div>
                                        </div>
                                    </div>
                                    <div class="fleft ticket">{{optionItem.voteCount+optionItem.fakeCount}}票</div>
                                    <div class="fleft ticket">{{((optionItem.voteCount+optionItem.fakeCount)/(item.voteTotalCount+item.fakeTotalCount)*100).toFixed(2)}}%</div>
                                </div>
                                <div v-else>
                                    <div class="fleft">
                                        <p style="padding-bottom: 10px">{{optionItem.optionName}}</p>
                                        <div class="vote-progress">
                                            <div class="true fleft" :style="{'width':(optionItem.voteCount/item.voteTotalCount*100)+'%'}"></div>
                                        </div>
                                    </div>
                                    <div class="fleft ticket">{{optionItem.voteCount}}票</div>
                                    <div class="fleft ticket">{{(optionItem.voteCount/item.voteTotalCount*100).toFixed(2)}}%</div>
                                </div>
                            </div>
                        </div>
                        <div class="fleft vote-type">
                            <p>
                                <span>开放时间：</span>
                                <span>{{item.startTime}}</span>～
                                <span>{{item.endTime}}</span>
                            </p>
                            <p>
                                <span>出现频道：</span>
                                <span v-for="channelsItem in item.channels" style="background: #ddd;margin-right: 10px;padding: 2px">{{channelsItem.name}}</span>
                            </p>
                            <p>
                                <span>出现位置：</span>
                                <span>置顶在列表第{{item.position}}个卡片</span>
                            </p>
                            <p>
                                <span>投票类型：</span>
                                <span v-if="item.type==0">单选</span>
                                <span v-if="item.type==1">多选</span>
                            </p>
                            <p v-if="item.type==1&&item.selectCount">
                                <span>最多选择：{{item.selectCount}}个</span>
                            </p>
                        </div>
                    </div>
                    <div>
                        <button class="button is-info" @click="goEdit(1,item)">编辑</button>
                        <button class='button is-danger' @click="deleteVote(item,index)">删除</button>
                    </div>
                </article>
            </div>
            <div v-if="count > 0" class="clearfix">
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="search.page"
                        :page-size="search.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="count"
                        class="fright">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="投票编辑" :visible.sync="visible" :lock-scroll="false" width="80%">
            <div class="vote-title margin-left">
                <div>
                    <span>从投票库选择</span>
                    <el-select v-model="modal.title" filterable placeholder="请选择" style="width:50%">
                        <el-option
                                v-for="item in initTitle"
                                :key="item.voteId"
                                :label="item.title"
                                :value="item.voteId">
                        </el-option>
                    </el-select>
                    <router-link :to="{name: 'votingContentLibrary'}">新增投票</router-link>
                </div>
            </div>

            <div class="block vote-content margin-left margin-top">
                <div class="fleft">
                   <span>开放时间</span>
                    <el-date-picker
                            v-model="tempTime"
                            type="datetimerange"
                            @change="changeTime"
                            placeholder="选择时间范围">
                    </el-date-picker>
                </div>
                <div class="fleft margin-left">
                    <span>开放频道</span>
                    <el-select v-model="modal.channelIds" multiple filterable placeholder="请选择" style="width: 400px">
                        <el-option
                                v-for="item in initChannels"
                                :key="item.channelId"
                                :label="item.name"
                                :value="item.channelId">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="margin-left">
                <span>出现位置：置顶在列表的第<input type="number" style="width: 50px" v-model.number="modal.position">个位置</span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible = false">取 消</el-button>
                <el-button type="primary" @click="doSave">确 定</el-button>
             </span>
        </el-dialog>
    </div>
</template>
<script type="text/babel">
    import mock from './mock'
    import { formatDate } from 'UTILS/date';
    export default {
        data(){
            return {
                list:[],
                count:0,
                search:{
                    title:'',
                    page:1,
                    pageSize:20,
                    startTime:'',
                    endTime:'',
                },
                modal: {
                    title: '',
                    voteId: 0,
                    startTime:'',
                    endTime:'',
                    channelIds:[],
                    position:1,
                },
                visible: false,
                initChannels:[],
                initTitle:[],
                tempTime:[],
            }
        },
        mounted(){
            this.getList(this.search);
            this.initData();
        },
        methods:{
            changeTime(){
                this.modal.startTime=formatDate(new Date(this.tempTime[0]).getTime(),'yyyy-MM-dd hh:mm:ss')
                this.modal.endTime=formatDate(new Date(this.tempTime[1]).getTime(),'yyyy-MM-dd hh:mm:ss')
                console.log(this.modal)
            },
            initData(){
                HttpRequest.get('/admin.php?method=blogger.getTags').then(response => {
                    this.initChannels = _.toArray(response.data.channels);
                })
                this.initTitle=mock.data.list;
                HttpRequest.get('/admin.php?method=fashion.getVoteList').then(response => {
                    this.initTitle = _.toArray(response.data.list);
                })
            },

            changeShowFake(num,index){
                if(this.list[index].isShowFake!==num){
                    this.list[index].isShowFake=num;
                }
            },

            deleteVote(item,index){
                if(confirm("确认要删除投票？")){
                    HttpRequest.get('/admin.php?method=fashion.deleteVote', {voteId:item.voteId}).then(response => {
                        if (response.data.success) {
                            this.$message("删除成功")
                            this.list.splice(index,1)
                        }
                    })
                }
            },

            doSave() {
                let params = Object.assign({},this.modal)

                if(!params.title){
                    this.$message("请填写标题")
                    return;
                }
                console.log(params)
                HttpRequest.get('/admin.php?method=main.DoSaveVote', params).then(response => {
                    if (response.data.success === 1) {
                        this.$message("保存成功")
                        this.visible = false;
                        /*HttpRequest.get('/admin.php?method=fashion.getVote', {voteId:response.data.voteId}).then(response => {
                            if (response.data) {
                                this.list.push(response.data)
                            }
                        })*/
                    }
                })
            },
            handleCurrentChange(value){
                if(this.search.page !== value){
                    this.search.page = value;
                    this.getList(this.search)
                }
            },
            getList(_params){
                let params = {
                    page: _params.page,
                    pageSize: _params.pageSize,
                }
                if (_params.title) {
                    params.title = _params.title
                }
                if(_params.startTime){
                    params.startTime=formatDate(new Date(_params.startTime).getTime(),'yyyy-MM-dd hh:mm:ss')
                }
                if(_params.endTime){
                    params.startTime=formatDate(new Date(_params.endTime).getTime(),'yyyy-MM-dd hh:mm:ss')
                }
                this.list=mock.data.list;
                this.count = mock.data.count;
                console.log(this.list)
                HttpRequest.get('/admin.php?method=main.getVoteList', params).then(response => {
                    if (response) {
                        this.list = _.toArray(response.data.list);
                        this.count = response.data.count;
                    }
                })
            },
            searchVote() {
                this.search.page = 1;
                this.getList(this.search)
            },
            goEdit(num,item) {
                if(num){
                    this.modal = item;
                    /* HttpRequest.get('/admin.php?method=fashion.getVote', {voteId:item.voteId}).then(response => {
                         if (response) {
                             this.modal = response.data;
                         }
                     })*/
                }else{
                    this.modal={
                        title: '',
                        voteId: 0,
                        startTime:'',
                        endTime:'',
                        channelIds:[],
                        position:1,
                    }
                }
                this.visible=true;

            },
            goBack(){
                this.visible=false;
            },
            clear() {
                this.search.title = '';
                this.search.page = 1;
                this.getList(this.search)
            },
        }
    }
</script>
<style lang="less" scoped>
    .like-tabs {
        border-bottom: 1px solid #eee;
        margin-bottom: 30px;
    }
    .like-button {
        padding-left: 10px;
    }
    .likeTabItem{
        line-height: 60px;
        height: 50px;
        font-size: 16px;
        padding: 0 4px;
        box-sizing: border-box;

    }
    .likeTabItem :hover {
        color: #ae0fff
    }
    .active {
        border-bottom: 1px solid #337ab7;
    }
    .search-component {
        display: flex;
        label {
            margin: 5px 5px 0 0;
        }
        .button {
            margin-left: 5px;
        }
    }
    .vote-card{
        display: block;
        background: #fff;
        border:1px solid #b4bccc;
        border-radius: 5px;
        padding: 20px 30px 20px;
        .vote-tab{
            padding: 10px 0 10px;
            span{
                font-size: 16px;
                color: #000;
                margin-right: 20px;
            }
            .color{
                color: #666;
            }
            span.vote-active{
                color: blue;
            }
        }

    }
    .vote-title{
        color:#337ab7;
        font-weight: bold;
        font-size: 16px;
        .title-con{
            margin-left: 10px;
            color: #000;
        }
    }
    .vote-content{
        overflow: hidden;
        .vote-type{
            width:250px;
            color: #000;
            p{
                margin-top: 20px;
            }
        }
        .vote-options{
            overflow: hidden;
            width:600px;
            font-weight: bold;
            color: #000;
            .vote-item{
                overflow: hidden;
                padding: 10px 0 10px;
                .ticket{
                    padding-top: 20px;
                    margin-left: 20px;
                    width:70px
                }
            }
            .vote-progress{
                width:300px;
                height:10px;
                overflow: hidden;
                background: #ccc;
                .true{
                    height:10px;
                    background: #445588;
                }
                .fake{
                    height:10px;
                    background: #f58a0f;
                }
            }
        }

    }
</style>
